import React, { Component } from "react";
import { PageHeader } from "antd";
import BandejaAguinaldo from "./BandejaAguinaldo";
import AsistenteAguinaldo from "./AsistenteAguinaldo";
import ModalImpresionAguinaldo from "./ModalImpresionAguinaldo";
import "./GenerarAguinaldo.css";

/**
 * Generar Aguinaldo: bandeja de procesos ↔ asistente por pasos (mismo patrón que PreNomina, que
 * alterna la lista y la prenómina abierta en una sola ruta).
 *
 * Antes era una sola pantalla que creaba un MovimientoPermanente por empleado; ahora el aguinaldo
 * se prepara como borrador y se aplica directamente en la prenómina elegida (ordinaria o un
 * periodo extraordinario). Ver Controllers/Prenomina/procesoAguinaldo.controllers.js.
 */
class GenerarAguinaldo extends Component {
  state = {
    vista: "bandeja",
    procesoId: null,
    // Cambia en cada apertura para que el asistente se monte limpio (nuevo u otro proceso).
    claveAsistente: 0,
    imprimirId: null,
  };

  abrir = (procesoId) => {
    this.setState((prev) => ({ vista: "asistente", procesoId, claveAsistente: prev.claveAsistente + 1 }));
  };

  render() {
    const { vista, procesoId, claveAsistente, imprimirId } = this.state;
    return (
      <div className="aguinaldo">
        <PageHeader
          title="Generar Aguinaldo"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
        />

        {vista === "bandeja" ? (
          <BandejaAguinaldo
            onNuevo={() => this.abrir(null)}
            onAbrir={(id) => this.abrir(id)}
            onImprimir={(id) => this.setState({ imprimirId: id })}
          />
        ) : (
          <AsistenteAguinaldo
            key={claveAsistente}
            procesoId={procesoId}
            onSalir={() => this.setState({ vista: "bandeja", procesoId: null })}
            onImprimir={(id) => this.setState({ imprimirId: id })}
          />
        )}

        <ModalImpresionAguinaldo
          visible={!!imprimirId}
          procesoId={imprimirId}
          onCancel={() => this.setState({ imprimirId: null })}
        />
      </div>
    );
  }
}

export default GenerarAguinaldo;
